import { CorePagination } from '@/components/Pagination';
import CoreTable from '@/components/Table';
import { Typography } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { useCoreContext } from '@/core';
import EmployeeTableColumns from '../../components/TableColum';

const EmployeeTable = () => {
  const { loading, error, dataListEmployee, setValue, getValues } = useCoreContext();
  const tableColumns = EmployeeTableColumns();

  return (
    <>
      {error && <div>Error</div>}
      {!error && (
        <div>
          <CoreTable
            columns={tableColumns}
            dataSource={get(dataListEmployee, 'data') ?? []}
            tableName='Center'
            loading={loading}
          />
          <div className='flex mt-4 justify-between'>
            <Typography.Title level={3}>
              Total:
              {get(dataListEmployee, 'count') > 999 ? '>= 1000' : get(dataListEmployee, 'count')}
            </Typography.Title>
            <CorePagination
              total={get(dataListEmployee, 'count') ?? 0}
              defaultPageSize={20}
              showSizeChanger
              pageSizeOptions={['5', '10', '20']}
              onChange={(page, pageSize) => {
                setValue('page', page);
                setValue('limit', pageSize);
              }}
              current={getValues('page')}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EmployeeTable;
